import { ReactNode, useRef } from "react";
import {
    createTableScrollableStore,
    TableScrollableStore,
    TableScrollableStoreContext,
} from "src/components-mui/base/table-scrollable/store/table-scrollable-store";

interface ITableScrollableProviderProps {
    children: ReactNode;
}

export const TableScrollableProvider = ({ children }: ITableScrollableProviderProps) => {
    const storeRef = useRef<TableScrollableStore | null>(null);
    storeRef.current ??= createTableScrollableStore();

    return <TableScrollableStoreContext.Provider value={storeRef.current}>{children}</TableScrollableStoreContext.Provider>;
};
